import React from 'react';
import { Button, Modal } from 'antd';
import intl from 'react-intl-universal';

const PayOrderConfirmModal = ({ open, onOk, onCancel }) => {
  return (
    <Modal
      title={intl.get('bill_pay_order_list_modal_confirm_generate_qrcode')}
      open={open}
      footer={
        <>
          <Button type="ghost" onClick={onCancel}>
            {intl.get('app_confirm_cancel_btn')}
          </Button>
          <Button type="primary" onClick={onOk}>
            {intl.get('bill_pay_order_list_modal_confirm_generate_btn')}
          </Button>
        </>
      }
    >
      <div>{intl.get('bill_pay_order_list_modal_making_info')}</div>
    </Modal>
  );
};

export default PayOrderConfirmModal;
